import { render, staticRenderFns } from "./DraftPriceView.vue?vue&type=template&id=29cafce3&"
import script from "./DraftPriceView.vue?vue&type=script&lang=js&"
export * from "./DraftPriceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports